import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import ClassNames from 'classnames';
import StyledLink from 'components/StyledLink';
import { makeSelectSiteCopy } from 'containers/Main/selectors';
import { getSiteCopy } from 'containers/Main/actions';
import Colors from 'utils/colors';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import CorporateDialogMenu from './CorporateDialogMenu';
import { BIG_LOGO } from '../constants';
export const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 75,
  },
  bar: {
    backgroundColor: '#FFF',
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    height: 75,
    display: 'flex',
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '0 5%',
    justifyContent: 'center',
  },
  toolbarWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  toolBar: {
    padding: 0,
  },
  brandText: {
    height: 30,
    marginRight: 48,
    [theme.breakpoints.down('600')]: {
      marginLeft: 20,
    },
  },
  navMenuTex: {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
  },
  activeMenu: {
    fontFamily: 'MadaBold',
    fontSize: 17,
    color: theme.palette.text.secondary,
  },
  hamburgerMenuContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  hamburgerMenu: {
    color: Colors.primary,
    fontSize: 35,
    cursor: 'pointer',
  },
  menuItem: {
    marginLeft: 12,
    marginRight: 12,
  },
  linkBtn: {
    fontFamily: 'MadaBold',
    height: 40,
    backgroundColor: theme.palette.text.secondary,
    color: '#fff',
    width: 175,
    fontSize: 14,
    marginLeft: 12,
    paddingTop: 11,
    paddingBottom: 11,
    boxShadow: 'none',
    '&: hover': {
      backgroundColor: theme.palette.text.secondary,
    },
    [theme.breakpoints.down('1080')]: {
      width: 100,
    },
  },
});

const menuList = ['about', 'team', 'sponsors', 'enterprise'];

class CorporateHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activePath: window.location.pathname,
      menuItems: this.getFilteredItems(props.siteCopyData),
      dialogOpen: false,
    };
  }

  componentDidMount() {
    this.props.getSiteCopy();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.siteCopyData !== nextProps.siteCopyData &&
      !_isEmpty(nextProps.siteCopyData)
    ) {
      const filteredItems = this.getFilteredItems(nextProps.siteCopyData);

      this.setState({
        menuItems: filteredItems,
      });
    }
  }

  getFilteredItems = siteCopyData => {
    const filteredItems = [];
    if (!_isEmpty(siteCopyData)) {
      siteCopyData.forEach(el => {
        if (menuList.includes(el.slug)) {
          filteredItems.push(el);
        }
      });
      filteredItems.push({
        name: 'Sponsors',
        slug: 'sponsors',
      });
    }
    return filteredItems;
  };

  redirect = link => {
    this.closeDialog();
    if (link) {
      this.props.history.push(`/company/${link}`);
    } else {
      this.props.history.push('/');
    }
  };

  handleClick = link => this.setState({ activePath: link });

  openDialog = () => {
    this.setState({
      dialogOpen: true,
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { menuItems, dialogOpen, activePath } = this.state;
    return (
      <div className={classes.root}>
        <CorporateDialogMenu
          open={dialogOpen}
          handleClose={this.closeDialog}
          redirect={this.redirect}
          menuItems={menuItems}
          menuList={menuList}
        />
        <Grid container className={classes.toolbarWrapper}>
          <AppBar position="static" className={classes.bar}>
            <Toolbar className={classes.toolBar}>
              <Grid
                container
                direction="row"
                alignItems="center"
                className={classes.menuWrapper}
              >
                <Hidden smDown>
                  <Grid item>
                    <StyledLink link="/">
                      <img
                        src={BIG_LOGO}
                        alt="Logo"
                        className={classes.brandText}
                      />
                    </StyledLink>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="row"
                    sm
                    justify="flex-end"
                    alignItems="center"
                  >
                    {!_isEmpty(menuItems) &&
                      !_isEmpty(menuList) &&
                      menuList.map(item => {
                        const data = _find(menuItems, { slug: item });
                        const isActive = data
                          ? activePath.includes(data.name.toLowerCase())
                          : false;
                        return (
                          <Grid
                            item
                            key={data.slug}
                            className={classes.menuItem}
                          >
                            <StyledLink
                              link={`/company/${data.slug}`}
                              onClick={() =>
                                this.handleClick(`/company/${data.slug}`)
                              }
                            >
                              <Typography
                                className={ClassNames(
                                  classes.navMenuTex,
                                  isActive && classes.activeMenu,
                                )}
                              >
                                {data.name}
                              </Typography>
                            </StyledLink>
                          </Grid>
                        );
                      })}
                    <StyledLink link="/">
                      <ButtonBase
                        classes={{
                          root: classes.linkBtn,
                        }}
                        disableFocusRipple
                        disableRipple
                      >
                        CREDIBLEMIND HOME
                      </ButtonBase>
                    </StyledLink>
                  </Grid>
                </Hidden>
                <Hidden mdUp>
                  <Grid item xs={8} className={classes.brandWrapper}>
                    <img
                      src={BIG_LOGO}
                      alt="Logo"
                      className={classes.brandText}
                    />
                  </Grid>
                  <Grid item xs={4} className={classes.hamburgerMenuContainer}>
                    <IconButton onClick={this.openDialog}>
                      <MenuIcon className={classes.hamburgerMenu} />
                    </IconButton>
                  </Grid>
                </Hidden>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
      </div>
    );
  }
}

CorporateHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  siteCopyData: PropTypes.object,
  history: PropTypes.object,
  getSiteCopy: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  siteCopyData: makeSelectSiteCopy(),
});

function mapDispatchToProps(dispatch) {
  return {
    getSiteCopy: () => dispatch(getSiteCopy()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withStyles(styles),
  withConnect,
  withRouter,
)(CorporateHeader);
